import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';

const AuthorCard = (props) => {
  const { content } = props;
  const imgUrl = buildImageSrc(content.avatar, 300, 3, 2);
  const linkUrl = buildLinkObj({ link: content.slug });
  return (
    <div className="col-sm col-4 slick-creator-card-container">
      <a rel={getRel(linkUrl)} className="tw-cursor-pointer" href={linkUrl.href}>
        <LazyLoadImage
          imgComponent={
            <img
              className="tw-block tw-rounded tw-z-[-1] tw-max-w-full tw-object-cover tw-mb-3"
              src={imgUrl}
              alt={content.avatar.name}
            />
          }
        />
        <h6 className="text-left mt-3 slick-creator-card-title">{content.name}</h6>
      </a>
    </div>
  );
};

export default AuthorCard;
